// import "../libs/spinner"

export default function (context) {
    const modal = $(context).is('.edit-dialog.modal') ? $(context) : $('.edit-dialog.modal', context)
    if (!modal.length) {
        return
    }
    modal.on('shown.bs.modal', () => {
        modal.find('form').on('success.submitted.coing', () => modal.modal('hide'))
    })
    modal.on('hidden.bs.modal', function () {
        $(this).find('h2,.modal-body').html('')
    });
    modal.find('.btn-update').on('click', function (e) {
        if (modal.find('.active form').length) {
            modal.find('.active form').trigger('submit');
        } else {
            modal.find('form').trigger('submit');
        }
        return false;
    });
}
